import { initialMaterialState, IMaterialState } from '../state/material.state';
import { MaterialAction, EMaterialActions } from '../actions/material.action';


export function materialReducers(state = initialMaterialState, action: MaterialAction): IMaterialState {
    switch (action.type) {

        case EMaterialActions.GetAllMaterialStockSuccess: {
            // console.log(action.payload)
            return {
                ...state,
                getAllMaterialStockSuccess: action.payload,
                getAllMaterialStockError: null
            };
        }
        case EMaterialActions.GetAllMaterialStockError: {
            return {
                ...state,
                getAllMaterialStockError: action.payload,
                getAllMaterialStockSuccess: null
            };
        }

        case EMaterialActions.GetAllMaterialsSuccess: {
            // console.log(action.payload)
            return {
                ...state,
                getAllMaterialSuccess: action.payload,
                getAllMaterialError: null
            };
        }
        case EMaterialActions.GetAllMaterialsError: {
            return {
                ...state,
                getAllMaterialError: action.payload,
                getAllMaterialSuccess: null
            };
        }
        case EMaterialActions.GetAllMaterialsByCompanyIdSuccess: {
            // console.log(action.payload)
            return {
                ...state,
                getAllMaterialsByCompanyIdSuccess: action.payload,
                getAllMaterialError: null
            };
        }
        case EMaterialActions.GetAllMaterialByCompanyIdError: {
            return {
                ...state,
                getAllMaterialByCompanyIdError: action.payload,
                getAllMaterialSuccess: null
            };
        }
        case EMaterialActions.GetMaterialsByStatusIdSuccess: {
            // console.log(action.payload)
            return {
                ...state,
                getMaterialsByStatusIdSuccess: action.payload,
                getMaterialsByStatusIdError: null
            };
        }
        case EMaterialActions.GetMaterialsByStatusIdError: {
            return {
                ...state,
                getMaterialsByStatusIdError: action.payload,
                getMaterialsByStatusIdSuccess: null
            };
        }
        case EMaterialActions.GetMaterialsByAgentIdSuccess: {
            // console.log(action.payload)
            return {
                ...state,
                getMaterialsByAgentIdSuccess: action.payload,
                getMaterialsByAgentIdError: null
            };
        }
        case EMaterialActions.GetMaterialsByAgentIdError: {
            return {
                ...state,
                getMaterialsByAgentIdError: action.payload,
                getMaterialsByAgentIdSuccess: null
            };
        }
        case EMaterialActions.GetAddMaterialSuccess: {
            return {
                ...state,
                getAddMaterialSuccess: action.payload,
                getAddMaterialError: null
            };
        }
        case EMaterialActions.GetAddMaterialError: {
            return {
                ...state,
                getAddMaterialError: action.payload,
                getAddMaterialSuccess: null
            };
        }
        case EMaterialActions.ImportMaterialSuccess: {
            return {
                ...state,
                importMaterialSuccess: action.payload,
                importMaterialError: null
            };
        }
        case EMaterialActions.ImportMaterialError: {
            return {
                ...state,
                importMaterialError: action.payload,
                importMaterialSuccess: null
            };
        }
        case EMaterialActions.GetEditMaterialSuccess: {
            return {
                ...state,
                getEditMaterialSuccess: action.payload,
                getEditMaterialError: null
            };
        }
        case EMaterialActions.GetEditMaterialError: {
            return {
                ...state,
                getEditMaterialError: action.payload,
                getEditMaterialSuccess: null
            };
        }
        case EMaterialActions.GetMaterialCodeSuccess: {
            return {
                ...state,
                getMaterialCodeSuccess: action.payload,
                getMaterialCodeError: null
            };
        }
        case EMaterialActions.GetMaterialCodeError: {
            return {
                ...state,
                getMaterialCodeError: action.payload,
                getMaterialCodeSuccess: null
            };
        }
        case EMaterialActions.InActivateMaterialSuccess: {
            return {
                ...state,
                inActivateMaterialSuccess: action.payload,
                inActivateMaterialError: null
            };
        }
        case EMaterialActions.InActivateMaterialError: {
            return {
                ...state,
                inActivateMaterialError: action.payload,
                inActivateMaterialSuccess: null
            };
        }
        case EMaterialActions.GetMatInventorySuccess: {
            return {
                ...state,
               getMatInventorySuccess: action.payload,
               getMatInventoryError: null
            };
        }
        case EMaterialActions.GetMatInventoryError: {
            return {
                ...state,
                getMatInventoryError: action.payload,
                getMatInventorySuccess: null
            };
        }
        case EMaterialActions.GetAddTypeSuccess: {
            return {
                ...state,
               getAddTypeSuccess: action.payload,
               getAddTypeError: null
            };
        }
        case EMaterialActions.GetAddTypeError: {
            return {
                ...state,
                getAddTypeError: action.payload,
                getAddTypeSuccess: null
            };
        }
        case EMaterialActions.GetAddUOMSuccess: {
            return {
                ...state,
               getAddUOMSuccess: action.payload,
               getAddUOMError: null
            };
        }
        case EMaterialActions.GetAddUOMError: {
            return {
                ...state,
                getAddUOMError: action.payload,
                getAddUOMSuccess: null
            };
        }
        case EMaterialActions.GetAddAlergensSuccess: {
            return {
                ...state,
               getAddAlergensSuccess: action.payload,
               getAddAlergensError: null
            };
        }
        case EMaterialActions.GetAddAlergensError: {
            return {
                ...state,
                getAddAlergensError: action.payload,
                getAddAlergensSuccess: null
            };
        }
        case EMaterialActions.GetSubGroupTypeSuccess: {
            return {
                ...state,
               getSubGroupTypeSuccess: action.payload,
               getSubGroupTypeError: null
            };
        }
        case EMaterialActions.GetSubGroupTypeError: {
            return {
                ...state,
                getSubGroupTypeError: action.payload,
                getSubGroupTypeSuccess: null
            };
        }
        //importSheet
        case EMaterialActions.GetImportExcelSheetSuccess: {
            return {
                ...state,
                getImportExcelSheetSuccess: action.payload,
                getImportExcelSheetError: null
            };
        }
        case EMaterialActions.GetImportExcelSheetError: {
            return {
                ...state,
                getImportExcelSheetError: action.payload,
                getImportExcelSheetSuccess: null
            };
        }
        default: {   
            return state;
          }
    }

}